import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.last-index-of";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.match";
import NativeModules from "react-native-web/dist/exports/NativeModules";
import { getAssetByID } from "./AssetRegistry";
import AssetSourceResolver from "./AssetSourceResolver";

var _customSourceTransformer;

var _serverURL;

var _scriptURL;

var _sourceCodeScriptURL;

function getSourceCodeScriptURL() {
  if (_sourceCodeScriptURL) {
    return _sourceCodeScriptURL;
  }

  var sourceCode = nativeExtensions && nativeExtensions.SourceCode;

  if (!sourceCode) {
    sourceCode = NativeModules && NativeModules.SourceCode;
  }

  _sourceCodeScriptURL = sourceCode.scriptURL;
  return _sourceCodeScriptURL;
}

function getDevServerURL() {
  if (_serverURL === undefined) {
    var sourceCodeScriptURL = getSourceCodeScriptURL();
    var match = sourceCodeScriptURL && sourceCodeScriptURL.match(/^https?:\/\/.*?\//);

    if (match) {
      _serverURL = match[0];
    } else {
      _serverURL = null;
    }
  }

  return _serverURL;
}

function _coerceLocalScriptURL(scriptURL) {
  if (scriptURL) {
    if (scriptURL.startsWith('assets://')) {
      return null;
    }

    scriptURL = scriptURL.substring(0, scriptURL.lastIndexOf('/') + 1);

    if (!scriptURL.includes('://')) {
      scriptURL = 'file://' + scriptURL;
    }
  }

  return null;
}

function getScriptURL() {
  if (_scriptURL === undefined) {
    _scriptURL = _coerceLocalScriptURL(getSourceCodeScriptURL());
  }

  return _scriptURL;
}

export function setCustomSourceTransformer(transformer) {
  _customSourceTransformer = transformer;
}
export default function resolveAssetSource(source) {
  if (typeof source === 'object') {
    return source;
  }

  var asset = getAssetByID(source);

  if (!asset) {
    return undefined;
  }

  var resolver = new AssetSourceResolver(getDevServerURL(), getScriptURL(), asset);

  if (_customSourceTransformer) {
    return _customSourceTransformer(resolver);
  }

  return resolver.defaultAsset();
}
Object.defineProperty(resolveAssetSource, 'setCustomSourceTransformer', {
  get: function get() {
    return setCustomSourceTransformer;
  }
});
var pickScale = AssetSourceResolver.pickScale;
export { pickScale };